// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

// feedback.js
export const RESPONSE_MSG = 'RESPONSE_MSG'
export const CLEAR_MSG = 'CLEAR_MSG'

// actor.js
export const SET_ACTORS = 'SET_ACTORS'
export const SET_ACTOR = 'SET_ACTOR'
export const FETCH_ACTOR_FAILURE = 'FETCH_ACTOR_FAILURE'

// country.js
export const SET_COUNTRIES = 'SET_COUNTRIES'
export const SET_COUNTRY = 'SET_COUNTRY'
export const FETCH_COUNTRY_FAILURE = 'FETCH_COUNTRY_FAILURE'

// department.js
export const SET_DEPARTMENTS = 'SET_DEPARTMENTS'
export const SET_DEPARTMENT = 'SET_DEPARTMENT'
export const FETCH_DEPARTMENT_FAILURE = 'FETCH_DEPARTMENT_FAILURE'

// municipality.js
export const SET_MUNICIPALITIES = 'SET_MUNICIPALITIES'
export const SET_MUNICIPALITY = 'SET_MUNICIPALITY'
export const FETCH_MUNICIPALITY_FAILURE = 'FETCH_MUNICIPALITY_FAILURE'

// district.js
export const SET_DISTRICTS = 'SET_DISTRICTS'
export const SET_DISTRICT = 'SET_DISTRICT'
export const FETCH_DISTRICT_FAILURE = 'FETCH_DISTRICT_FAILURE'

// town.js
export const SET_TOWNS = 'SET_TOWNS'
export const SET_TOWN = 'SET_TOWN'
export const FETCH_TOWN_FAILURE = 'FETCH_TOWN_FAILURE'

// maillon.js
export const SET_MAILLONS = 'SET_MAILLONS'
export const SET_MAILLON = 'SET_MAILLON'
export const FETCH_MAILLON_FAILURE = 'FETCH_MAILLON_FAILURE'

// chain.js
export const SET_CHAINS = 'SET_CHAINS'
export const SET_CHAIN = 'SET_CHAIN'
export const FETCH_CHAIN_FAILURE = 'FETCH_CHAIN_FAILURE'

// user.js
export const SET_USERS = 'SET_USERS'
export const SET_USER = 'SET_USER'

// key.js
export const SET_KEYS = 'SET_KEYS'
export const SET_KEY = 'SET_KEY'

// log.js
export const SET_LOGS = 'SET_LOGS'
export const SET_LOG = 'SET_LOG'

// domain.js
export const SET_DOMAINS = 'SET_DOMAINS'
export const SET_DOMAIN = 'SET_DOMAIN'
export const FETCH_DOMAIN_FAILURE = 'FETCH_DOMAIN_FAILURE'

// sae-type.js
export const SET_SAE_TYPES = 'SET_SAE_TYPES'
export const SET_SAE_TYPE = 'SET_SAE_TYPE'
export const FETCH_SAE_TYPE_FAILURE = 'FETCH_SAE_TYPE_FAILURE'

// thematic-type.js
export const SET_THEMATIC_TYPES = 'SET_THEMATIC_TYPES'
export const SET_THEMATIC_TYPE = 'SET_THEMATIC_TYPE'
export const FETCH_THEMATIC_TYPE_FAILURE = 'FETCH_THEMATIC_TYPE_FAILURE'

// service.js
export const SET_SERVICES = 'SET_SERVICES'
export const SET_SERVICE = 'SET_SERVICE'
export const FETCH_SERVICE_FAILURE = 'FETCH_SERVICE_FAILURE'

// language.js
export const SET_LANGUAGES = 'SET_LANGUAGES'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const FETCH_LANGUAGE_FAILURE = 'FETCH_LANGUAGE_FAILURE'

// event-type.js
export const SET_EVENT_TYPES = 'SET_EVENT_TYPES'
export const SET_EVENT_TYPE = 'SET_EVENT_TYPE'
export const FETCH_EVENT_TYPE_FAILURE = 'FETCH_EVENT_TYPE_FAILURE'

// organisator-type.js
export const SET_ORGANISATOR_TYPES = 'SET_ORGANISATOR_TYPES'
export const SET_ORGANISATOR_TYPE = 'SET_ORGANISATOR_TYPE'
export const FETCH_ORGANISATOR_TYPE_FAILURE = 'FETCH_ORGANISATOR_TYPE_FAILURE'

// actor-type.js
export const SET_ACTOR_TYPES = 'SET_ACTOR_TYPES'
export const SET_ACTOR_TYPE = 'SET_ACTOR_TYPE'
export const FETCH_ACTOR_TYPE_FAILURE = 'FETCH_ACTOR_TYPE_FAILURE'

// school-level.js
export const SET_SCHOOL_LEVELS = 'SET_SCHOOL_LEVELS'
export const SET_SCHOOL_LEVEL = 'SET_SCHOOL_LEVEL'
export const FETCH_SCHOOL_LEVEL_FAILURE = 'FETCH_SCHOOL_LEVEL_FAILURE'

// card.js
export const SET_CARDS = 'SET_CARDS'

// about.js
export const SET_ABOUT = 'SET_ABOUT'

// session.js
export const SET_SESSIONS = 'SET_SESSIONS'
export const SET_SESSION = 'SET_SESSION'
export const FETCH_SESSION_FAILURE = 'FETCH_SESSION_FAILURE'



// WEBPACK FOOTER //
// ./resources/assets/js/store/mutation-types.js